const content = {
	"consent": {
		"title": "Consentimento AmbiFi",
		"liabilityRelease": "Liberação de responsabilidade e suposição expressa de risco",
		"termsPrompt": "Leia atentamente ANTES de concordar com os termos e condições do uso do programa digital AmbiFi. Trate esta licença e contrato como propriedade valiosa.",
		"terms": "Termos e Condições",
		"agree": "Você concorda com o consentimento acima?",
		"sorry": "Desculpe, você deve concordar em seguir em frente. Você concorda?"
	},
	"buttons": {
		"yes": "Sim",
		"no": "Não",
		"close": "Fechar"
	},
	"home": {
		"myActivities": "Minhas atividades",
		"hello": "Bem-vindo ao AmbiFi!",
		"helloPrompt": "",
		"welcomeTitle": "Hora de se tornar extremamente produtivo.",
		"samplesTitle": "Exemplo de atividades",
		"gettingStartedTitle": "Começando",
		"recentTitle": "Atividades recentes",
		"userGuide": "Baixe o Guia do Usuário para obter mais informações.",
		"quickStart": "Experimente a atividade Início Rápido para fornecer uma visão geral dos recursos.",
		"diveIn": "Experimente uma amostra se você quiser decolar imediatamente.",
		"noDownloads": "Você ainda não baixou nenhuma atividade. Selecione AmbiFi Cloud para começar.",
		"downloads": "No menu no canto superior esquerdo, selecione uma atividade para começar.",
		"ambiFiCloud": "O AmbiFi Cloud é onde você descobre, cria, edita e compartilha atividades.",
		"productive": "Para uma experiência de edição mais produtiva, faça login no AmbiFi Cloud a partir do seu laptop ou desktop.",
		"copyright": "© 2020 AmbiFi, Inc. Todos os direitos reservados.",
		"version": "Versão",
		"buttons": {
			"startNew": "Comece novo",
			"resumeLast": "Retomar por último"
		}
	},
	"mira": {
		"speaks": {
			"checklist": "Atividade para",
			"list": "Lista",
			"section": "Seção",
			"resetChecklistPrompt": "Tem certeza de que deseja redefinir a atividade atual?",
			"resettingList": "Redefinindo lista",
			"resettingSection": "Redefinindo seção",
			"checkAll": {
				"response1": "Com grandes poderes vem grandes responsabilidades.",
				"response2": "A única vez em que você deve fazer curvas é em uma pista de corrida.",
				"response3": "Acabei correndo uma vez. Acabei com uma barra de reboque na minha hélice.",
				"response4": "Agora, alguns minutos podem economizar uma vida inteira.",
				"response5": "Algo realmente importante é arriscar tudo?",
				"response6": "Desisto! Você é sem esperança!"
			},
			"unableToDictate": "Desculpe, não sou capaz de ditar no contexto atual.",
			"unableToClearText": "Desculpe, não consigo limpar o texto do item atual.",
			"goAhead": "Continue"
		},
		"responses": {
			"check": "Verifica",
			"skip": "Pular",
			"removeCheck": "Removendo cheque"
		}
	},
	"menu": {
		"notLoggedIn": "Não está logado",
		"login": "Conecte-se",
		"openCloud": "Abra AmbiFi Cloud",
		"home": "Casa",
		"toggleSectionsMenu": "Alternar vista de olho de pássaro",
		"ambiFiCloud": "AmbiFi Cloud",
		"quickSync": "Sincronização Rápida",
		"resetChecklist": "Redefinir atividade atual",
		"resetList": "Redefinir lista atual",
		"resetSection": "Redefinir seção atual",
		"expandAll": "Expandir todos",
		"collapseAll": "Recolher todos",
		"bigCheckOverlay": "Sobreposição de cheque grande",
		"checklistsTitle": "Atividades",
		"currentSession": "Sessão atual",
		"session": "Sessão",
		"prefsTitle": "Preferências",
		"storeCloudHistory": "Armazenar histórico da nuvem",
		"animatedScrolling": "Rolagem Animada",
		"showLabelCheck": "Mostrar rótulo 'Verificar'",
		"audioTitle": "Mira",
		"voiceRecognitionTitle": "Fale com Mira",
		"showHistory": "Mostrar histórico local",
		"hideHistory": "Ocultar histórico local",
		"focusedMode": "Modo Focado",
		"moveForward": "Sempre avançar",
		"audio": "Áudio",
		"tracking": "Rastreamento",
		"miraSnarky": "Mira é cínica",
		"readSectionItemDelay": "Atraso do item de seção de leitura",
		"voiceSpeed": "Velocidade da voz",
		"primaryVoice": "Voz primária",
		"secondaryVoice": "Voz secundária",
		"challengeResponseMode": "Resposta do desafio",
		"useGrammar": "Usar modelo gramatical",
		"showVoiceCommands": "Mostrar comandos",
		"sayCheck": "Say Check",
		"nightMode": "Modo noturno",
		"talkToMiraMessage": "Fale com a Mira Informação",
		"talkToMira": "Fale com Mira",
		"learnMore": "Saber mais",
		"interruptMira": "Interrupt Mira",
		"backgroundNoise": "Barulho de fundo",
		"styles": "Estilos",
		"filters": "Filtros",
		"itemsFontSize": "Tamanho da fonte dos itens",
		"itemsAlign": "Alinhamento do item",
		"layoutTitle": "Aparência",
		"horizontal": "Horizontal",
		"vertical": "Vertical",
		"simple": "Simples",
		"checkbar": "Barra de verificação",
		"checkbarSize": "Tamanho da barra de verificação",
		"checkedColor": "Cor marcada",
		"echoCancellation": "Cancelamento de eco",
		"columnWidth": "Largura da coluna",
		"maxColumnWidth": "Largura máxima da coluna"
	},
	"keywords": {
		"emergency": "Emergência"
	},
	"units": {
		"kias": "KIAS",
		"knots": "Knots",
		"mph": "MPH"
	},
	"alerts": {
		"lang": "Escolha um idioma",
		"goto": "Você quer prosseguir?",
		"activityNoContent": "Esta atividade não possui nenhum conteúdo. Você precisa de pelo menos um item. Não pode ser exibido.",
		"congrats": "Parabéns!",
		"congratsMessage": "Você concluiu a atividade.",
		"resetChecklist": "Redefinir atividade atual",
		"resetChecklistMessage": "Tem certeza de que deseja redefinir a atividade atual? Isso criará uma nova sessão.",
		"resetList": "Redefinir lista atual",
		"resetListMessage": "Tem certeza de que deseja redefinir a lista atual {list.name}?",
		"resetSection": "Redefinir seção atual",
		"resetSectionMessage": "Tem certeza de que deseja redefinir a seção atual {section.name}?",
		"skippedItems": "Você tem alguns itens ignorados nesta seção. Deseja retornar ou avançar?",
		"micPermissions": "Como é a primeira vez que você concede permissões de microfone ao aplicativo, será necessário ativar o recurso Talk to Mira mais uma vez.",
		"micPermissionsFailed": "A verificação de permissão para o microfone falhou. Você pode não ter dado permissão. Pode ser necessário desinstalar e reinstalar o aplicativo para dar permissão.",
		"voicesAndroid": "Com o mecanismo de fala do Google, há centenas de vozes para escolher. Nota: Existem diferentes mecanismos de fala em um dispositivo. Os dispositivos Samsung normalmente usam como padrão seus próprios, mas também existe um mecanismo de fala do Google para o qual você pode alternar. Nas Configurações do dispositivo, você pode alternar os mecanismos de voz e baixar novas vozes. Normalmente, isso pode ser encontrado nas configurações de acessibilidade ou nas configurações de idioma e entrada. Se você trocar de mecanismo ou baixar novas vozes, precisará descarregar e recarregar o aplicativo para ver as novas vozes disponíveis.",
		"talkToMira": "O Talk to Mira permite o reconhecimento de voz para controlar a atividade. É um método de entrada de muitos que fornecemos para controlar a atividade. Tecnologias como Siri, Google Assistant e Alexa aproveitam o enorme processamento do servidor em voz e têm um ótimo processamento de ruído de fundo. Eles são bons para perguntas e respostas únicas, mas não são bons quando você deseja interagir em tempo real, como dizer cheque, cheque, cheque rapidamente.\n\nPara o AmbiFi, é essencial o requisito de fala para texto offline e a capacidade de reagir rapidamente. As tecnologias para isso percorreram um longo caminho, mas ainda não são 100% ideais. Por um lado, o ruído de fundo pode realmente afetar a precisão. Nós adicionamos um controle deslizante de ruído de fundo para ajudar com isso. Os valores típicos devem estar no intervalo de 2 a 4. Quanto mais alto, mais ele tenta reduzir o ruído de fundo. Muito alto e até o que você diz é considerado ruído de fundo.\n\nAlém disso, quando Mira está falando, ela pode desarmar o reconhecimento e, por padrão, o reconhecimento de voz é desativado quando ela está falando. Você tem que esperar até que ela termine para dar um comando. Adicionamos um recurso Interrupt Mira que desativará isso. Somente ligue isso ao usar um fone de ouvido. Ao usar um fone de ouvido, como o áudio não está sendo ouvido pelo microfone, a interrupção pode funcionar.\n\nEm nossos testes, o reconhecimento de voz funciona muito bem quando combinado com um fone de ouvido bluetooth de última geração e ainda há muitas coisas que estamos explorando para melhorar no futuro.",
		"voiceCommands": "\n\nCHECK\nCHECK ITEM\nCHECK IT\nNEXT\nNEXT ITEM\n\nSKIP\nSKIP ITEM\nSKIP IT\n\nLOCATE\nLOCATE ITEM\n\nREAD ITEM\nREAD CURRENT ITEM\n\nREAD SECTION\nREAD CURRENT SECTION\n\nCHECK SECTION\nCHECK CURRENT SECTION\n\nRESET ACTIVITY\nRESET CURRENT ACTIVITY\nRESET LIST\nRESET CURRENT LIST\nRESET SECTION\nRESET CURRENT SECTION\n\nOPEN COMMENTS\nCLOSE COMMENTS\nSHOW COMMENTS\nHIDE COMMENTS\n\nOPEN NOTES\nCLOSE NOTES\nSHOW NOTES\nHIDE NOTES\n\nOPEN LOGBOOK\nCLOSE LOGBOOK\nSHOW LOGBOOK\nHIDE LOGBOOK\n\nOPEN CLOCK\nCLOSE CLOCK\nSHOW CLOCK\nHIDE CLOCK\n\nOPEN NAV OVERLAY\nCLOSE NAV OVERLAY\nSHOW NAV OVERLAY\nHIDE NAV OVERLAY\n\nOPEN BIG CHECK OVERLAY\nCLOSE BIG CHECK OVERLAY\nSHOW BIG CHECK OVERLAY\nHIDE BIG CHECK OVERLAY\n\nEMERGENCY\nEMERGENCY LIST\n\nMIRA {List Name}\nMIRA {Section Name}\n\nMIRA GOTO SKIPPED ITEMS\nMIRA GOTO UNCHECKED ITEMS\n\nMIRA PAUSE\nMIRA PLAY\nMIRA RESUME\nMIRA STOP\n\nMIRA SILENCE\nMIRA SHUT UP\nMIRA BE QUIET\n\nAFFIRMATIVE\nNEGATIVE\n\nGO BACK",
		"acousticModel": "O mecanismo de reconhecimento de voz suporta diferentes modelos acústicos. Você pode experimentar diferentes modelos que podem fornecer uma melhor precisão com sua voz.",
		"audioMode": "O suporte operacional suporta diferentes modos de áudio para capturar áudio. Você pode experimentar modos diferentes.",
		"useGrammar": "Existem dois tipos de modelos que o mecanismo de reconhecimento de voz suporta. O padrão é um modelo de linguagem e nos testes parece mais preciso. Você pode tentar usar o Modelo de Gramática para ver se ele fornece melhores resultados.",
		"listensAggressively": "Por padrão, é aplicado um filtro de rejeição que rejeita algumas palavras comuns. Isso desativa o filtro de rejeição.",
		"interruptMira": "Quando Mira está falando, o mecanismo de reconhecimento de voz é desligado porque Mira ouve-se falando e pode desarmar. Se você estiver usando um fone de ouvido, o microfone não ouvirá o que Mira está dizendo e isso pode ser ativado. Recomenda-se que LIGUE ao usar um fone de ouvido.",
		"backgroundNoise": "Este é um filtro de ruído de fundo. Os valores válidos estão tipicamente na faixa de 2 a 4, com 2 removendo a menor quantidade de ruído.",
        "miraListeningDelay": "Determina quanto tempo Mira escuta depois que ela termina de falar. O microfone fica vermelho quando ela está ouvindo e volta ao verde quando não está ouvindo. Quando ela não está ouvindo, você deve pronunciar a palavra de alerta (MIRA ou HEY MIRA ou HELLO MIRA) para que ela ouça um comando.",
		"showVoiceCommands": "Mostrar todos os comandos de voz que o mecanismo de reconhecimento de voz está vendo.",
		"echoCancellation": "Isso remove o áudio reproduzido pelo aplicativo do áudio capturado pelo microfone. Alterar isso requer uma reinicialização do aplicativo para entrar em vigor.",
		"buttons": {
			"yes": "Sim",
			"no": "Não",
			"cancel": "Cancelar",
			"submit": "Salvar + Sair"
		}
	},
	"items": {
		"shared": {
			"ok": "Está bem ✓"
		},
		"yesNo": {
			"yes": "Sim",
			"no": "Não",
			"na": "N / D"
		},
		"image": {
			"showFullscreen": "Mostrar tela cheia"
		},
		"video": {
			"playFullscreen": "Reproduzir tela cheia"
		}
	}
};

export default content;